import { useContext } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { AuthContext } from '../Context/AuthContext';

export default function PrivateRoute({ allowedRoles }) {
  const { auth } = useContext(AuthContext);
  const userRole = auth?.user?.role;

  if (!auth?.isAuthenticated) return <Navigate to="/login" replace />;
  if (!allowedRoles.includes(userRole)) return <Navigate to="/login" replace />;

  return <Outlet />;
}